import { render, staticRenderFns } from "./VersionLabelDialog.vue?vue&type=template&id=1e9da82e&scoped=true"
import script from "./VersionLabelDialog.vue?vue&type=script&lang=js"
export * from "./VersionLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./VersionLabelDialog.vue?vue&type=style&index=0&id=1e9da82e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9da82e",
  null
  
)

export default component.exports